/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Snigdha <snigdha.dhanireddy@mroads.com>, August 2020
 * @format
 * @flow
 */

import keyMirror from "key-mirror";

export const ActionTypes = keyMirror({
    // Activate device
    DEVICE_ACTIVATION: undefined,
    DEVICE_ACTIVATION_REQUEST: undefined,
    DEVICE_ACTIVATION_SUCCESS: undefined,
    DEVICE_ACTIVATION_FAILURE: undefined,

    ACTIVE_DEVICE_INFO: undefined,

    UPDATE_DEVICE_INFO: undefined,
    UPDATE_DEVICE_API_DATA: undefined,

    LOGIN: undefined,
    LOGIN_REQUEST: undefined,
    LOGIN_SUCCESS: undefined,
    LOGIN_FAILURE: undefined,

    STORE_INFO: undefined,
    STORE_INFO_REQUEST: undefined,
    STORE_INFO_SUCCESS: undefined,
    STORE_INFO_FAILURE: undefined,

    REACTIVATE_DEVICE: undefined,
    REACTIVATE_DEVICE_REQUEST: undefined,
    REACTIVATE_DEVICE_SUCCESS: undefined,
    REACTIVATE_DEVICE_FAILURE: undefined,

    UPDATE_CHECK: undefined,

    RETHINK_UPDATE_CHECKS: undefined,
    RETHINK_CLEAR_CHECKS: undefined,
    RETHINK_ADD_LOG: undefined,
    RETHINK_CLEAR_LOGS: undefined,
  
    SERVERAPP_ADD_LOG: undefined,
    SERVERAPP_CLEAR_LOGS: undefined,

    SERVERAPP_ADD_EXCEPTION: undefined,

    MENU_UPDATE: undefined,
    RETHINK_UPDATE_NOTIFICATIONS: undefined,

    UPDATE_SYNC_STATUS: undefined,

    UPDATE_NOTIFICATIONS: undefined,

    GET_STORE_BY_ID: undefined,
    GET_STORE_BY_ID_REQUEST: undefined,
    GET_STORE_BY_ID_SUCCESS: undefined,
    GET_STORE_BY_ID_FAILURE: undefined,

    ACKNOWLEDGE_NOTIFICATION: undefined,
    ACKNOWLEDGE_NOTIFICATION_REQUEST: undefined,
    ACKNOWLEDGE_NOTIFICATION_SUCCESS: undefined,
    ACKNOWLEDGE_NOTIFICATION_FAILURE: undefined,

    TABLE_RECEIPT_PRINT: undefined,
    TABLE_RECEIPT_PRINT_REQUEST: undefined,
    TABLE_RECEIPT_PRINT_SUCCESS: undefined,
    TABLE_RECEIPT_PRINT_FAILURE: undefined,

    UPDATE_CURRENCY: undefined,
    ADD_FB_NETWORK_LOG: undefined,
    CLEAR_FB_NETWORK_LOG: undefined,

    SA_LOGIN: undefined,
    SA_LOGIN_REQUEST: undefined,
    SA_LOGIN_SUCCESS: undefined,
    SA_LOGIN_FAILURE: undefined,

    CASH_PAYMENT: undefined,
    CASH_PAYMENT_REQUEST: undefined,
    CASH_PAYMENT_SUCCESS: undefined,
    CASH_PAYMENT_FAILURE: undefined,

    CARD_PAYMENT: undefined,
    CARD_PAYMENT_REQUEST: undefined,
    CARD_PAYMENT_SUCCESS: undefined,
    CARD_PAYMENT_FAILURE: undefined,

    PAYMENT_INGENICO_COMPLETE: undefined,
    PAYMENT_INGENICO_COMPLETE_REQUEST: undefined,
    PAYMENT_INGENICO_COMPLETE_SUCCESS: undefined,
    PAYMENT_INGENICO_COMPLETE_FAILURE: undefined,
    
    VALIDATE_GIFTCARD: undefined,
    VALIDATE_GIFTCARD_REQUEST: undefined,
    VALIDATE_GIFTCARD_SUCCESS: undefined,
    VALIDATE_GIFTCARD_FAILURE: undefined,

    PAYMENT_GIFT_CARD_INIT: undefined,
    PAYMENT_GIFT_CARD_INIT_REQUEST: undefined,
    PAYMENT_GIFT_CARD_INIT_SUCCESS: undefined,
    PAYMENT_GIFT_CARD_INIT_FAILURE: undefined,

    PAYMENT_GIFT_CARD_COMPLETE: undefined,
    PAYMENT_GIFT_CARD_COMPLETE_REQUEST: undefined,
    PAYMENT_GIFT_CARD_COMPLETE_SUCCESS: undefined,
    PAYMENT_GIFT_CARD_COMPLETE_FAILURE: undefined,

    GET_STORE_JOBS: undefined,
    GET_STORE_JOBS_REQUEST: undefined,
    GET_STORE_JOBS_SUCCESS: undefined,
    GET_STORE_JOBS_FAILURE: undefined,

    EMAIL_RECEIPT: undefined,
    EMAIL_RECEIPT_REQUEST: undefined,
    EMAIL_RECEIPT_SUCCESS: undefined,
    EMAIL_RECEIPT_FAILURE: undefined,
  
    SMS_RECEIPT: undefined,
    SMS_RECEIPT_REQUEST: undefined,
    SMS_RECEIPT_SUCCESS: undefined,
    SMS_RECEIPT_FAILURE: undefined,
  
    PRINT_RECEIPT: undefined,
    PRINT_RECEIPT_REQUEST: undefined,
    PRINT_RECEIPT_SUCCESS: undefined,
    PRINT_RECEIPT_FAILURE: undefined,

    UPDATE_FILTERS: undefined,
    UPDATE_STATE: undefined,
    UPDATE_CHECK_SORT_FILTER: undefined,
    UPDATE_VIEW_TYPE: undefined,

    RETRY_POS_PAYMENT: undefined,
    RETRY_POS_PAYMENT_REQUEST: undefined,
    RETRY_POS_PAYMENT_SUCCESS: undefined,
    RETRY_POS_PAYMENT_FAILURE: undefined,

    ADD_PRINT_LOG: undefined,
    CLEAR_PRINT_LOG: undefined,

    UPDATE_FB_CHECK_FILTERS: undefined,
});